export enum EnvironmentEnum {
  LOCAL = 'local',
  DEVELOPMENT = 'development',
  STAG = 'stag',
  PROD = 'prod',
}

export enum RolesEnum {
  ADMIN = 'ADMIN',
}

export enum StorageEnum {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  USER_ID = 'user_id',
  STATUS_LOGIN = 'statusLogin',
}

export enum LanguageEnum {
  EN = 'en',
}

export enum ButtonTypeEnum {
  PRIMARY = 'primary',
  DANGER = 'danger',
}

export enum FilterReportEnum {
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
  YEARLY = 'Yearly',
}

export enum PaymentMethodEnum {
  NONE = "None",
  CASH = "Cash",
  CREDIT_CARD = "Credit Card",
  CHECK = "Check",
  MONEY_ORDER = "Money Order",
  BANK_WIRE = "Bank Wire",
  FINANCE = "Finance",
}

export enum JobInvoiceStatusEnum {
  DRAFT = 'Draft',
  SENT = 'Sent',
  OPEN = 'Open',
  CLOSED = 'Closed',
  CANCELLED = 'Cancelled',
  VOID = 'Void',
}

export enum JobTypeEnum {
  RESIDENTIAL = "Residential",
  COMMERCIAL = "Commercial",
  INSURANCE = "Insurance",
}